(ns practitest.frontend.forms3.run.timer
  (:require
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.components2.tooltip :as tooltip]
    [practitest.frontend.forms3.run.events :as run-events]
    [practitest.frontend.forms3.run.subs :as run-subs]
    [re-frame.core :as re-frame]
    [reagent.core :as r]))

(defn- timer [{:keys [running? elapsed on-start on-stop on-cancel on-change]}]
  (r/with-let [handle        (atom nil)
               local-elapsed (r/atom 0)
               editing?      (r/atom false)
               draft         (r/atom "")
               stop!         (fn [] (when-let [h @handle] (js/clearInterval h) (reset! handle nil)))]
    (let [is-running?   (some? @handle)
          current-secs  @local-elapsed
          commit!       (fn []
                        (when (fu/valid-duration? @draft)
                          (let [[h m s] (clojure.string/split @draft #":" 3)
                                new-secs (+ (* 3600 (js/parseInt h))
                                            (* 60 (js/parseInt m))
                                            (js/parseInt s))]
                            (reset! local-elapsed new-secs)
                            (on-change new-secs))))]
      (cond
        (and running? (not is-running?))
        (do (reset! local-elapsed elapsed)
            (reset! handle (js/setInterval #(swap! local-elapsed inc) 1000)))

        (and (not running?) is-running?)
        (stop!))

      [:<>
       [:input.run-timer-input
        {:class       (cond running?  "run-timer-input--running"
                            @editing? "run-timer-input--editing"
                            :else     "run-timer-input--paused")
         :type        "text"
         :read-only   (or running? (not @editing?))
         :value       (if @editing?
                        @draft
                        (fu/format-duration (fu/parse-duration (if is-running? current-secs elapsed))))
         :on-click    (when-not (or running? @editing?)
                        (fn []
                          (reset! draft (fu/format-duration (fu/parse-duration elapsed)))
                          (reset! editing? true)))
         :on-change   #(reset! draft (.. % -target -value))
         :on-blur     (fn []
                        (when @editing? (commit!))
                        (reset! editing? false))
         :on-key-down (fn [e]
                        (case (.-key e)
                          "Enter"  (when (fu/valid-duration? @draft) (.blur (.-target e)))
                          "Escape" (reset! editing? false)
                          nil))}]
       [tooltip/tooltip
        {:placement "top"}
        (fn [hover-props]
          (if running?
            [:button.run-timer-btn.run-timer-btn--stop
             (merge hover-props
                    {:on-click (fn []
                                 (mixpanel/track "Run Form Actions" {"Action" "Timer Stopped"})
                                 (on-stop @local-elapsed))})
             [icons/mux-stop-icon]]
            [:button.run-timer-btn
             (merge hover-props
                    {:on-click (fn []
                                 (mixpanel/track "Run Form Actions" {"Action" "Timer Started"})
                                 (on-start))})
             [icons/mux-start-icon]]))
        (if running?
          (get-translation "run.timer.pause" "Pause timer")
          (get-translation "run.timer.start" "Start timer"))]])
    (finally
      (stop!)
      (when (pos? @local-elapsed)
        (on-cancel @local-elapsed)))))

(defn run-timer []
  (fn []
    (let [enabled?  @(re-frame/subscribe [::run-subs/time-management-enabled?])
          elapsed   @(re-frame/subscribe [::run-subs/elapsed])
          running?  @(re-frame/subscribe [::run-subs/running?])]
      (when enabled?
        [:div.run-timer
         [:span.run-timer-clock [icons/clock]]
         [timer
          {:running?   running?
           :elapsed    elapsed
           :on-start   (fn []
                         (re-frame/dispatch [::run-events/start-timer])
                         (re-frame/dispatch [::run-events/save-duration {:paused? false}]))
           :on-stop    (fn [current-elapsed]
                         (re-frame/dispatch [::run-events/set-elapsed current-elapsed])
                         (re-frame/dispatch [::run-events/stop-timer])
                         (re-frame/dispatch [::run-events/save-duration {:paused? true :elapsed current-elapsed}]))
           :on-cancel  (fn [current-elapsed]
                         (re-frame/dispatch [::run-events/save-duration {:elapsed current-elapsed}]))
           :on-change  (fn [new-elapsed]
                         (re-frame/dispatch [::run-events/set-elapsed new-elapsed])
                         (re-frame/dispatch [::run-events/save-duration {:paused? true :elapsed new-elapsed}]))}]]))))

(defn run-footer [_form-props _standard-save-form!]
  (let [{:keys [next_instances]}
        @(re-frame/subscribe [::run-subs/navigation-data])
        next-inst (first next_instances)]
    [:div.run-footer-actions
     [run-timer]
     [buttons/button
      {:primary?  true
       :disabled? (nil? next-inst)
       :text      (get-translation "run.nav.run-next-test" "Run Next Test")
       :on-click  (fn []
                    (mixpanel/track "Run Form Actions" {"Action" "Run Next Test"})
                    (re-frame/dispatch [::run-events/stop-timer])
                    (re-frame/dispatch [::run-events/navigate-to-instance
                                        (:id next-inst)
                                        (:testset_id next-inst)]))}]]))
